import React, { InputHTMLAttributes } from 'react';
import { BiProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

export type Props = BiProps & InputHTMLAttributes<HTMLInputElement>;

const BiInput: React.FC<Props> = React.forwardRef<HTMLInputElement, Props>(
  ({ biData, innerRef, stopPropagation, ...props }, ref) => {
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return (
      <input
        {...props}
        ref={node => {
          setTrackingRef(node);
          innerRef && innerRef(node);

          // TODO: Replace with `setRefs` utility, but we need to move that out of da-ds first
          if (!ref) {
            return;
          }

          if (typeof ref === 'function') {
            ref(node);
            return;
          }

          ref.current = node;
        }}
      />
    );
  }
);
BiInput.displayName = 'BiInput';

export default BiInput;
